<template>
  <div class="createPage">
    <!-- header start -->
    <van-nav-bar 
      title="创建纪念馆"
      class="mynavbar" 
      left-arrow 
      fixed 
      :z-index="99" 
      @click-left="onClickLeft" 
      :border="false"
    />
    <!-- header end -->

    <img src="@/assets/images/create/step01_bg.jpg" class="createBg">
    
    <div class="block step01">
      <div class="cell-title">选择纪念馆类型</div>
      <div class="raido-box">
        <van-radio-group v-model="radio">
          <van-radio name="1" checked-color="transparent">单人馆</van-radio>
          <van-radio name="2" checked-color="transparent">双人馆</van-radio>
        </van-radio-group>
      </div>
      <div class="btn-area">
        <van-button round plain class="whitebtn minbtn"
          :to="{path:'/Step02', query:{s:radio} }"
         replace>下一步</van-button>
      </div>
      <!-- @click="goStep()"  -->
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        radio: '1',
      }
    }, 
    methods :{
      onClickLeft() {
        this.$router.go(-1)
      },
      goStep(){
        // to="/Step02" 
        this.$router.push('/Step02?s='+ this.radio);
      }
    },
  }
</script>

<style>
.step01 .cell-title{
  font-size: 13px;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}
.createPage .block.step01{
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  justify-content: center;
}
.step01 .van-radio-group{
  width: 100%;
}
.step01 .van-radio__icon--checked + .van-radio__label{
  color: #fff !important;
}
.step01 .raido-box{
  width: 100%;
}
.step01 .van-radio__icon .van-icon{
  border-color: #555;
}
.step01 .van-radio__icon--checked .van-icon{
  border-color: #fff !important;
}
.step01 .raido-box .van-radio{
  padding: 15px 16px;
}
</style>
